export default __webpack_public_path__ + "static/media/INV-logo.61c18aca.png";